import { useCallback, useState } from 'react';

interface UseBoolean {
  value: boolean;
  set: (value: boolean) => void;
  toggle: () => void;
  setTrue: () => void;
  setFalse: () => void;
}

export const useBoolean = (initial = false): UseBoolean => {
  const [value, set] = useState<boolean>(initial);

  return {
    value,
    set,
    toggle: useCallback(() => set((_value) => !_value), []),
    setTrue: useCallback(() => set(true), []),
    setFalse: useCallback(() => set(false), []),
  };
};
